import { useTranslation } from "react-i18next";
import { mainURL } from "../utils/common";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import { BuildingLeftMenuList } from "../utils/constants";
import { RenderNavItem } from "../components/RenderNavItem";

const Building_Sanction_Important_EODB_circulars = () => {
  const { t } = useTranslation();
  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="alt" />
        </div>
      </section>
      {/* End Slider */}
      <section className="section inner-pad1">
        <div className="container">
          <div className="row">
            <div className="col-lg-3">
              <div className="site-menu  min-height-400">
                <nav className="sidebar card py-2">
                  <ul className="nav flex-column" id="nav_accordion">
                    {BuildingLeftMenuList.map((item, index) => (
                      <RenderNavItem item={item} index={index} t={t} />
                    ))}
                  </ul>
                </nav>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="container">
                <div className="row">
                  <div className="inner-title2 bas">
                    <h3 className="fontSizeClass"> {t("Circular")} </h3>
                  </div>
                  <div className="mayor-table health-dept-table">
                    <table
                      width="95%"
                      align="center"
                      className="table table-bordered officials"
                    >
                      <tbody>
                        <tr bgcolor="#302ba0" align="center" valign="middle">
                          <td
                            width="30%"
                            className="text-white tble-brder-left"
                          >
                            {t("Circular No")}
                          </td>
                          <td width="18%" className="text-white">
                            {t("Date")}
                          </td>
                          <td
                            width="52%"
                            className="text-white tble-brder-right"
                          >
                            {t("Subject")}
                          </td>
                        </tr>
                        <tr>
                          <td valign="middle">
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"08c40769-5457-44bd-acb1-ec37e6a19f34"}&tenantId=km.kolkata`}
                            >
                              {t("MC's Circular No.176 of 2019-20")}
                            </a>
                          </td>
                          <td valign="middle">{t("04-March-2020")}</td>
                          <td valign="middle">
                            {t(
                              "Disposal of Pending Files under section 393A of the KMC Act 1980"
                            )}
                          </td>
                        </tr>
                        <tr>
                          <td valign="middle">
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"a8ea8c73-c42e-40a9-968e-5ec2bb8cfa25"}&tenantId=km.kolkata`}
                            >
                              {t("MC's Circular No.175 of 2019-20")}
                            </a>
                          </td>
                          <td valign="middle">{t("04-March-2020")}</td>
                          <td valign="middle">
                            {t(
                              "Reduction of Procedure for sanction and completion cum Occupancy of Building"
                            )}
                          </td>
                        </tr>
                        <tr>
                          <td valign="middle">
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"e470aaea-45e6-4ac5-bf06-d1d1f6c556ad"}&tenantId=km.kolkata`}
                            >
                              {t("MC's Circular No.174 of 2019-20")}
                            </a>
                          </td>
                          <td valign="middle">{t("04-March-2020")}</td>
                          <td valign="middle">
                            {t(
                              "Risk based classification of the building on the basis of risk factors"
                            )}
                          </td>
                        </tr>
                        <tr>
                          <td valign="middle">
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"dda5d318-6675-4c89-bac3-32f7a500b88d"}&tenantId=km.kolkata`}
                            >
                              {t("MC's Circular No.173 of 2019-20")}
                            </a>
                          </td>
                          <td valign="middle">{t("04-March-2020")}</td>
                          <td valign="middle">
                            {t("Management of Building Department")}
                          </td>
                        </tr>
                        <tr>
                          <td valign="middle">
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"1a10de6d-a7fa-404f-a3f9-73fdb1eac4b9"}&tenantId=km.kolkata`}
                            >
                              {t("MC's Circular No.172 of 2019-20")}
                            </a>
                          </td>
                          <td valign="middle">{t("04-March-2020")}</td>
                          <td valign="middle">
                            {t(
                              "Amendments made in Building Rule regarding Quality of Construction"
                            )}
                          </td>
                        </tr>
                        <tr>
                          <td valign="middle">
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"f8699e26-d60b-40b1-abd1-744b39d7a41e"}&tenantId=km.kolkata`}
                            >
                              {t("MC's Circular No.171 of 2019-20")}
                            </a>
                          </td>
                          <td valign="middle">{t("04-March-2020")}</td>
                          <td valign="middle">
                            {t(
                              "Reduction of Timeline for sanction and Completion cum Occupancy of Building"
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <br />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Building_Sanction_Important_EODB_circulars;
